import { useState, useEffect } from "react";
import { apiClient } from "../../services/api";

function ScheduledTasks() {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    loadRules();
  }, []);

  async function loadRules() {
    setLoading(true);
    setError("");
    try {
      const data = await apiClient.get("/scheduled-tasks");
      setRules(data.rules || []);
    } catch (err) {
      setError(err.message || "Failed to load scheduled tasks");
    } finally {
      setLoading(false);
    }
  }

  function formatExpression(expr) {
    if (!expr) return "—";
    if (expr.startsWith("rate(")) {
      const inner = expr.slice(5, -1);
      return `Every ${inner}`;
    }
    if (expr.startsWith("cron(")) {
      return `Cron: ${expr.slice(5, -1)}`;
    }
    return expr;
  }

  if (loading) return <div className="loading-state">Loading scheduled tasks…</div>;
  if (error) return <div className="error-state">{error}</div>;

  return (
    <div className="scheduled-tasks">
      <div className="scheduled-tasks-header">
        <h3>EventBridge Scheduled Rules</h3>
        <button className="btn-secondary" onClick={loadRules}>Refresh</button>
      </div>
      {rules.length === 0 ? (
        <p className="empty-state">No scheduled rules found.</p>
      ) : (
        <div className="scheduled-tasks-list">
          {rules.map((rule) => (
            <div key={rule.name} className="scheduled-task-card">
              <div className="task-card-header">
                <span className="task-name">{rule.name}</span>
                <span className={`task-state ${rule.state === "ENABLED" ? "enabled" : "disabled"}`}>
                  {rule.state}
                </span>
              </div>
              <div className="task-card-body">
                <div className="task-detail">
                  <span className="task-label">Schedule</span>
                  <span className="task-value">{formatExpression(rule.scheduleExpression)}</span>
                </div>
                {rule.description && (
                  <div className="task-detail">
                    <span className="task-label">Description</span>
                    <span className="task-value">{rule.description}</span>
                  </div>
                )}
                {rule.targets.length > 0 && (
                  <div className="task-detail">
                    <span className="task-label">Target{rule.targets.length > 1 ? "s" : ""}</span>
                    <span className="task-value">
                      {rule.targets.map((t) => t.functionName).join(", ")}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default ScheduledTasks;
